export const PRODUCT_GRID_ITEMS_PER_PAGE = 9;

export enum ProductRecommendationView {
  'SLIDER',
  'GRID',
}
